import React from 'react';
import ReactDOM from 'react-dom/client';
import './styles/tokens.css';   // design tokens first, so everything can use them
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { initTheme } from './components/ui/themeStore';
import { installFetchInterceptor } from './api/fetchInterceptor';

// Install the auth interceptor before React mounts so every subsequent
// fetch (in the client wrapper or ad-hoc across editors) inherits the JWT.
installFetchInterceptor();

// Apply the saved accent theme to <html> before React mounts (no flash).
initTheme();

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();
